const app = {
    modal: {
        close: 'Close',
        ok: 'OK',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving...',
    },
    products: {
        title: 'Products',
        new: 'New',
        all: 'All Products',
        sizes: '',
        excludeVAT: 'excl. VAT',
        startDesign: 'Start Design',
        searchResults: 'Search results for &quot;<strong>{query}</strong>&quot;',
        noResults: 'No products found',
        showInShop: 'Show the product in your store',
        connectProduct: 'Connect TiB Product',
        connectProductId: 'Shopify Product ID',
        regionFilter: {
            allRegions: 'All Regions',
            europe: 'Europe & Rest of World',
            america: 'North & South America',
            mixedCurrencyInfo:
                "Products that are produced exclusively at our US location or exclusively at our European location have only one price, shown in that location's currency ($ or €). Products produced at both locations show two prices accordingly. Invoicing is always carried out in the currency of the respective production location.",
        },
    },
    tibProductConnect: {
        error: {
            title: 'Product could not be Connected',
            variantNotFound: 'The following variants could not be matched:\n',
        },
        success: {
            title: 'Product Successfully Connected',
        },
    },
    mainShop: {
        title: 'My Stores',
    },
    orders: {
        title: 'Orders',
        personalized: 'Personalized orders',
        notEu: 'Non-EU orders',
        personalizedShort: 'Personalized',
        notEUShort: 'Not from the EU',
        addressMissing: 'Missing Address',
        all: 'All',
        splittedOrders: 'Part of this order:',
    },
    myStores: {
        title: 'My Stores',
        storeRegion: 'Store region',
        billingCurrency: 'Billing currency',
        activeButton: 'Active',
        inactiveButton: 'Inactive',
        viewStoreButton: 'View Store',
        editStoreDetailsButton: 'Edit store details',
        addProductButton: 'Add product',
        title2: 'Connect a new store',
        subtitle2: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        connectButton: 'Connect',
        brandDescriptions: {
            shopify:
                'Shopify is an attractive choice for small businesses, offering a comprehensive platform with easy-to-use tools and affordable pricing.',
            woocommerce: 'WooCommerce is an established and powerful e-commerce platform based on WordPress with extensive customization options.',
            amazon: 'Amazon is an attractive choice for small businesses, offering a comprehensive platform with easy-to-use tools and affordable pricing.',
            etsy: "Etsy offers an easy and fast way to get started selling and to connect with millions of active buyers around the world, making it an ideal choice for new sellers.<br><br>The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy, Inc.",
            tiktok: "TikTok Shop is ideal for sellers who want to leverage social commerce, combining TikTok's entertainment with a seamless shopping experience to reach a highly engaged audience.<br><br>Features: Access to a young, dynamic audience of over 1 billion active users &middot; Seamless integration with TikTok content &middot; Built-in tools for live shopping and in-app purchases.",
        },
        woocommerce: {
            modalTitle: 'Connect WooCommerce Store',
            modalDescription: 'Enter the URL of your WooCommerce store. You will then be redirected to your store to approve MarketPrint access.',
            modalConnect: 'Continue',
            shopUrlLabel: 'Store URL',
            shopUrlPlaceholder: 'https://mystore.com',
            shopUrlHint: 'The full URL of your WooCommerce store including https://',
            modalInfo:
                'You will be redirected to your WooCommerce installation and need to approve access for MarketPrint there. Make sure you are logged in to your WooCommerce store.',
            redirecting: 'Redirecting...',
            missingShopUrl: 'No shop URL provided.',
        },
        learnMoreLink: 'Learn more',
        noShops: 'There are currently no shops connected.',
        scopeButton: 'Update Shop',
        updateShopText:
            'At least one of your stores must be updated. <br>To do this, click on the “Update Shop” button and approve the request in Shopify.',
    },
    myDesign: {
        title: 'My Designs',
    },
    myDesignLibrary: {
        title: 'Design Library',
        deleteConfirm: 'Are you sure you want to delete this design?',
    },
    myNeckPrintDesignLibrary: {
        title: 'Neck Branding',
        deleteConfirm: 'Are you sure you want to delete this design?',
        lightGarment: 'All light garments',
        darkGarment: 'All dark garments',
        allGarments: 'Light and dark garments',
        selectBothImages: 'Please select an image for both light and dark garments.',
    },
    returns: {
        title: 'Returns management',
        noReturns: 'There are currently no returns.',
        startDate: 'Start date',
        endDate: 'End date',
        store: 'Store',
        status: {
            title: 'Status',
            PENDING: 'Pending',
            PARTIALLY_COMPLETED: 'Partially Completed',
            COMPLETED: 'Completed',
        },
        itemStatus: {
            allStatuses: 'All statuses',
            itemsPendingRefund: 'Items Pending Refund',
            PENDING: 'Pending',
            ACCEPTED: 'Accepted',
            REJECTED: 'Rejected',
            STORED: 'Stored',
            SOLD: 'Sold',
            complaintUnderReview: 'Complaint under review',
            complaintRejected: 'Complaint rejected',
            complaintAccepted: 'Complaint accepted',
        },
        combinedStatus: {
            RETURN_ANNOUNCED: 'Return announced',
            RETURN_STORED: 'Returned item stored',
            RETURN_REJECTED: 'Return rejected',
            RETURN_SOLD: 'Returned item sold',
            COMPLAINT_UNDER_REVIEW: 'Complaint under review',
            COMPLAINT_REJECTED: 'Complaint rejected',
            COMPLAINT_ACCEPTED: 'Complaint accepted',
        },
        search: 'Search',
        reset: 'Reset filters',
        searchPlaceholder: 'Search order or customer name',
        //tableHeaders:
        orderId: 'Order ID',
        orderName: 'Order',
        statusTitle: 'Status',
        date: 'Date',
        customer: 'Customer',
        isDone: 'Refunded to end customer?',
        product: 'Product',
        noProductTitle: 'No product title',
        subscription: 'Subscription',
        isReturnManagementActive: 'Return Management',
        frameUrl: 'IFrame URL',
        activate: 'Subscribe',
        deactivate: 'Unsubscribe',
        copiedToClipboard: 'Copied to clipboard',
    },
    resources: {
        title: 'Resources',
        blog: 'Print-On-Demand Blog',
        whatsappChannel: 'WhatsApp Channel',
        productAndDeliverInformation: 'Product and delivery information',
        productImages: 'Product Images',
        helpAndFaqs: 'Help & FAQs',
        bulkOrders: 'Bulk Orders',
        warehousing: 'Warehousing',
    },
    deliveryInformation: 'Delivery information',
    account: {
        affiliateProgram: 'Affiliate Program',
        title: 'Account',
        bundling: 'Bundling',
        invoices: 'Invoices',
        walletTransactions: 'Wallet Transactions',
        settings: 'Settings',
        myStores: 'My Stores',
        logout: 'Logout',
        logoutMessage: 'You have been logged out due to problems with your account.',
    },
    sampleOrder: {
        title: 'Create order',
        step1Title: 'Select Store',
        step2Title: 'Select Products',
        step3Title: 'Shipping Address',
        step4Title: 'Review & Submit',
        selectStoreSubtitle: 'Choose which store to order the sample through',
        submit: 'Place order',
        total: 'Total',
        country: 'Country *',
        firstName: 'First Name *',
        lastName: 'Last Name *',
        address1: 'Address Line 1 *',
        address2: 'Address Line 2',
        city: 'City *',
        zip: 'ZIP / Postal Code *',
        province: 'State',
        phone: 'Phone',
        email: 'Email',
        reviewStore: 'Selected Store',
        reviewProducts: 'Selected Product | Selected Products',
        invalidCity: 'City name looks too short.',
        invalidZip: 'This postal code does not match the selected country.',
        invalidStreet: 'Please enter street and house number.',
        provinceRequired: 'Please select a state.',
        invalidEmail: 'Please enter a valid email address.',
        countryPlaceholder: 'Select a country',
        countryRestricted: 'Only these countries can be delivered for the selected product region.',
        countrySearchPlaceholder: 'Search country...',
        countryNoMatch: 'No country found',
        region: 'Region',
        regionEu: 'Europe & Rest of World',
        regionUsa: 'USA',
        selectedItems: 'Selected products',
        totalQuantity: 'Total quantity',
        maxItems: 'Total quantity cannot exceed 200 items.',
        loadingProducts: 'Loading products...',
        noProducts: 'No products match your search.',
        steps: {
            store: 'Store',
            products: 'Products',
            shipping: 'Shipping',
            review: 'Review',
        },
        noPaymentMethod: 'No payment method is set up for this store yet. The order will only be processed once a payment method has been added.',
        addPaymentMethod: 'Add payment method',
        submitSuccess: 'Your sample order {orderId} has been created!',
        startAnother: 'Create another order',
        errorZipInvalid: 'The postal code is not valid for the selected country. Please check the shipping address.',
        errorZipStateMismatch: 'The postal code does not belong to the selected state. Please check the shipping address.',
        editAddress: 'Edit address',
        submitError: 'Something went wrong. Please try again.',
        priceHeader: 'Invoice amount',
        priceLoading: 'Calculating price...',
        priceError: 'The price could not be calculated. Please check the shipping address.',
        priceRetry: 'Recalculate',
        shipping: 'Shipping',
        netTotal: 'Subtotal (net)',
        tax: 'VAT ({rate}%)',
        vipDiscount: 'VIP customer discount',
        free: 'Free of charge',
        vatInfo6: 'Tax-free export in accordance with Section 6 UStG.',
        vatInfo6a: 'Tax-free intra-Community delivery in accordance with Section 6a UStG.',
    },
    pagination: {
        prev: 'Back',
        next: 'Next',
        further: 'Next',
        create: 'Create',
        save: 'Save',
    },
    search: {
        placeholder: 'Search',
    },
    sort: {
        value: 'Sort',
    },
    filter: {
        label: 'Filter',
        searchPlaceholder: 'Search categories...',
        clearAll: 'Clear all',
        noResults: 'No categories found',
    },
    creditCard: {
        error: {
            title: 'Credit card could not be deposited',
            tokenContent: 'Invalid credit card Information',
            backendContent: 'Error when storing the data',
        },
        success: {
            title: 'Successfully saved',
            content: 'Your credit card has been successfully deposited',
        },
    },
    welcomeBlock: {
        title: `Welcome{username}`,
        suggest: 'Browse our product portfolio and create your unique print on demand product in less than 2 minutes.',
        subtitle:
            "--- You will find up-to-date known issues <a target='_blank' rel='noopener noreferrer' href='https://help.marketprint.de/known-issues/'>here</a>. ---<br><br>The long-awaited <b>MarketPrint 2.0</b> The update is finally online! We have changed the entire frontend to offer you an even better user experience.<br><br>If there are still minor problems within the first two weeks, please call us on the phone number<b>+49 8261 7939101</b>.<br>Or leave your opinion and suggestions for future innovations at: <b>feedback@marketconsultive.de</b><br><br>We wish you a lot of fun with the new design and are looking forward to hearing from you! We are far from over and thank you for your loyalty.<br><br>- The complete team of <i>MarketConsultive GmbH</i><br><br>PS: A few exciting features, such as your own design library, will be made available to you in the next few weeks! Take a look at <a target='_blank' rel='noopener noreferrer' href='https://www.marketprint.de'>www.marketprint.de</a> over! In addition, we are planning a complete product portfolio of at least 20 (!) new best-selling products that will go online within the next weeks and months.",
        cta: 'Create a product now',
    },
    productsIntro: {
        title: 'Our product range',
    },
    currentOrders: {
        title: `Current orders:`,
        more: 'Show more...',
    },
    currentOrdersModal: {
        shopifyId: 'Shopify ID',
        trackingNumber: 'Shipment number(s)',
        moreInfo: 'More info',
        paymentMethod: 'Payment method',
        transactionNumber: 'Transaction number',
        ordered: 'Appointed',
        inProcess: 'In production',
        shipped: 'Shipped',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
        yes: 'Yes',
        no: 'No',
        btnUploadDesigns: 'Upload Designs',
        btnReleaseForProduction: 'Approve for production',
        btnViewOrder: 'Show Order',
        btnUpdateCustomerData: 'Update Address',
        updateCustomerData: 'Update Customer Data',
        btnDownloadInvoice: 'Download Invoice',
        textReleaseForProduction: 'Do you really want to approve this order for production?',
        orderReady: 'Order has been approved for production!',
        orderReadyErrorTitle: 'Order could not be approved for production!',
        orderReadyError: 'Check to see if all designs are complete!',
        btnUploadInvoices: 'Upload Invoice',
        invoice: 'Invoice',
        selectVariant: 'Choose a variant',
        selectImage: 'Personalized design',
        confirmationUpload: 'Upload successful!',
        notPayed: 'Payment to MarketPrint failed. Please try again in the settings or contact our support.',
        noPreview: 'Currently no preview for mugs! \n You can still upload the design.',
        for: 'for',
        btnRetryPayment: 'Retry payment',
        uploaded: 'Uploaded designs',
        downloadInvoice: 'Invoice Download',
        noInvoice: 'Invoice not available',
        noMockups: 'No mockups available for this product',
        btnCancel: 'Cancel order',
        cancelReason: 'Cancel reason',
        textCancel: 'Are you sure you want to cancel this order?',
        orderCancelErrorTitle: 'Order could not be cancelled',
        orderCancelled: 'Order has been cancelled',
        orderCancelError: 'The order might already be in production or shipped.',
        invoiceUploadErrorTitle: 'Invoice upload failed',
        invoiceUploadError: 'The invoice upload failed. Please try again later or refresh the page.',
        invoiceUploadSuccess: 'Invoice uploaded successfully',
        btnAddAddress: 'Add Address',
        addAddress: 'Add Shipping Address',
        firstName: 'First Name',
        lastName: 'Last Name',
        address1: 'Address',
        city: 'City',
        zip: 'ZIP Code',
        countryCode: 'Country Code',
        addressAddedSuccess: 'Address added successfully',
        addressAddedError: 'Failed to add address',
    },
    checklist: {
        title: `Your checklist`,
        subtitle: `Only a few steps left to set up your shop!`,
        installApp: `Install the MarketPrint app`,
        createProduct: `Creatie a product`,
        paymentMethod: `Select a payment method`,
    },
    todoOrders: {
        title: `Your TODO's`,
        subtitle: `Complete your orders`,
        order: `Load the invoice for the order <strong>#{id}</strong> high`,
    },
    sortOptions: {
        relevance: 'Relevance',
        newArrivals: 'Newcomer',
        bestSelling: 'Best-selling',
        priceLowHigh: 'Price Low High',
        priceHighLow: 'Price High Low',
        ratings: 'Review',
    },
    home: {
        bestseller: 'Current MarketPrint Bestsellers',
        newProducts: 'New Products',
        shopConnectSuccess: {
            title: 'Shop connected',
            content: 'Your shop has been successfully connected to MarketPrint.',
        },
        shopConnectError: {
            title: 'Shop connection error',
            content: 'An error occurred while connecting your shop to MarketPrint. Please try again later.',
            alreadyConnected: 'An error occurred while connecting your shop to MarketPrint: The shop is already connected to another account.',
        },
    },
    ordersIntro: {
        orders: 'Order overview',
        personalized: 'Personalized orders',
        notEu: 'Non-EU orders',
    },
    design: {
        editMode: 'Edit Mode',
        editingProduct: 'Editing:',
        personalizedEditLocked: 'Personalized products cannot be altered. Only the title, description and prices can be changed.',
        variantsAddOnly: 'Existing colors and sizes cannot be removed, only new ones can be added.',
        selectShop: 'For which Shop do you want to create a product?',
        selectShopTitle: 'Select Shop',
        front: 'Front',
        back: 'Back',
        left: 'Left',
        right: 'Right',
        colors: 'Colours',
        size: 'Size',
        sizes: 'Varying sizes',
        design: 'Design',
        neckPrint: 'Neck Print',
        waistband: 'Waistband',
        cuffLeft: 'Cuff Left',
        cuffRight: 'Cuff Right',
        collar: 'Collar',
        forearmRight: 'Forearm Right',
        forearmLeft: 'Forearm Left',
        useDifferentGarment: 'Use different images for light and dark garments',
        showGreenArea: 'Show green area',
        titleLibraryNeckPrints: 'Neck Print Library',
        countries: 'Countries',
        germany: 'Germany',
        austria: 'Austria',
        switzerland: 'Switzerland',
        landArea: 'Country / Area',
        alternativeDesign: 'Alternative Design',
        alternativeDesignColors: 'Alternative design for the following colors',
        productDescription: 'Product description',
        howToDesign: 'How to design this product',
        downloadProductData: 'Download product data sheet and mockups',
        designNote: 'Design creation notes',
        sizeChart: 'Size chart',
        insertGraphic: 'Insert graphic',
        moveLayerUp: 'Move layer up',
        moveLayerDown: 'Move layer down',
        important: `<span>Important:</span> Place your design inside the green outer marker. When crossing the lines, your design will not be printed completely on the product.`,
        productTitle: 'Product Titles',
        productTitlePlaceholder: 'Add a title',
        productDescriptionPlaceholder: 'Add description',
        doubleSidedPrint: 'Multi-sided printing - already included',
        additionalNeckPrice: 'Neck print - already included',
        purchasePriceVat: 'Purchase price (excl. VAT)',
        purchasePrice19Vat: 'Purchase price (incl. 19% VAT)',
        sellingPrice19VAt: 'Sales price (incl. 19% VAT)',
        sellingPrice: 'Sales price',
        profitMargin: 'Your profit margin (gross)',
        profitMarginWithVat: 'Your profit margin',
        price: 'Price',
        shippingCostsOverview: 'Overview of shipping costs',
        shippingPrice: 'Shipping price',
        shippingPricesAreNet: 'All prices are net.',
        shippingProduct: 'Product',
        usaShippingStandard: 'T-shirts and other products',
        usaShippingHeavy: 'Hoodies, sweatshirts, zippers, sweatpants',
        additionalPricePerProduct: 'An additional 0.84 € will be charged per additional product in the order',
        additionalItems: 'Additional items',
        addSizeChart: 'Add a size chart to the shop',
        publishProduct: 'Publish product in Shopify',
        collections: 'Collections',
        collectionsLoading: 'Loading collections...',
        noCollections: 'No collections available',
        collectionsSearch: 'Search collections...',
        collectionsNoResults: 'No matching collections',
        collectionsSelected: '{count} selected',
        catalogs: 'Catalogs',
        catalogsLoading: 'Loading catalogs...',
        noCatalogs: 'No catalogs available',
        catalogsSearch: 'Search catalogs...',
        catalogsNoResults: 'No matching catalogs',
        catalogsSelected: '{count} selected',
        shippingProfiles: 'Shipping profile',
        shippingProfilesLoading: 'Loading shipping profiles...',
        noShippingProfiles: 'No shipping profiles available',
        shippingProfilesSearch: 'Search shipping profiles...',
        shippingProfilesNoResults: 'No matching shipping profiles',
        shippingProfileDefault: 'MarketPrint default shipping',
        shopSelectionTitle: 'Select Shop',
        shopSelectionSubtitle: 'Choose which shop to add your product to',
        chooseMockup: 'Choose your mockup',
        titleLibrary: 'Your design library',
        addDesignLibrary: `Upload a new design`,
        personalProduct: 'This is a customizable product',
        tibProductFront: 'Optimize Front',
        tibProductBack: 'Optimize Back',
        tibProductSleeveLeft: 'Optimize Sleeve Left',
        tibProductSleeveRight: 'Optimize Sleeve Right',
        tibProductLeft: 'Optimize Left',
        tibProductRight: 'Optimize Right',
        tibProductFrontLeft: 'Optimize Front Left',
        tibProductFrontRight: 'Optimize Front Right',
        tibProductBackLeft: 'Optimize Back Left',
        tibProductBackRight: 'Optimize Back Right',
        tibProductSideLeft: 'Optimize Side Left',
        tibProductSideRight: 'Optimize Side Right',
        tibProductTop: 'Optimize Top',
        tibProductChestLeft: 'Optimize Left Chest',
        tibProductChestRight: 'Optimize Right Chest',
        tibProductForearmLeft: 'Optimize Left Forearm',
        tibProductForearmRight: 'Optimize Right Forearm',
        tibProductCuffLeft: 'Optimize Cuff Left',
        tibProductCuffRight: 'Optimize Cuff Right',
        tibProductWaistband: 'Optimize Waistband',
        tibProductCollar: 'Optimize Collar',
        tibProductAll: 'Optimize All',
        quality: {
            good: 'Good',
            normal: 'Means',
            bad: 'Bad',
        },
        productCreated: 'Created a product',
        productCreateError: 'Product could not be created',
        productUpdated: 'Product updated successfully',
        productUpdateError: 'Product could not be updated',
        maxOne: 'A maximum of one graphic',
        infoCanvas: `<span>Placement:</span> Front side of the canvas inside the dark grey frame,
              side
              Overlap up to the green line.`,
        infoPoster: `<span>Placement:</span> Placement of the
              Designs up to the outer green line. Gray
              Area is cut off during production.`,
        infoGlas: `<span>No placement:</span> For engraving work, we do not provide <b>any</b> placement for
                            Available, please change your vector graphics accordingly and then load the image
                            up again to adjust the placement.<br><br>
                      <span>Fixed aspect ratio:</span> Make sure that your SVG has the <b>width
                          {printMediumWidth} </b> and <b>Height {printMediumHeight}</b> hat.<br>
                            Alternatively, set the width and height so that they have the same aspect ratio as <b> {printMediumAspectRatio} </b>.<br><br>
                         <span>Only one design file:</span> There can be <b>only one</b> vector graphic for the design
                            be used.`,
        disabledStep2: `To get to the next step, you need to choose: Color, Size and Upload Image`,
        disabledStep3: `To proceed to the next step, you need to specify the product name, description and price`,
        uploadErrorMessageBeer:
            'SVG aspect ratio does not match the aspect ratio of the print medium (width/height = 1.67). Please try again with a matching file!',
        uploadErrorMessageWine:
            'SVG aspect ratio does not match the aspect ratio of the print medium (width/height = 1). Please try again with a matching file!',
        uploadErrorPngOnly: 'Please use a .png image for this product',
        uploadErrorTitle: 'Upload Error',
        sleeveRight: 'Sleeve Right',
        sleeveLeft: 'Sleeve Left',
        frontLeft: 'Front Left',
        frontRight: 'Front Right',
        backLeft: 'Back Left',
        backRight: 'Back Right',
        sideLeft: 'Side Left',
        sideRight: 'Side Right',
        top: 'Top',
        chestLeft: 'Left Chest',
        chestRight: 'Right Chest',
        combinedDesignTitle: 'Same design on all sides',
        combinedDesignDescription: 'Disable this option if you want to have different designs on the left and right slipper',
        designDownload: 'Design Download',
        addToShop: 'Add to shop',
        sizeChartTooltip: 'The size chart is a table that shows your customer measurements of the product.',
        supportedPrinterTypes: 'Printer Type:',
        printerType: {
            dtf: 'DTF',
            dtg: 'DTG',
            sublimation: 'Sublimation',
            laser: 'Laser',
            aop: 'AOP',
        },
        dtfModal: {
            headline: 'DTF Information',
            info: 'To ensure that your designs are optimally implemented in DTF printing, please note the following information:',
            points: [
                'No semi-transparent design elements: Transparencies or elements with reduced opacity cannot be displayed cleanly in DTF printing. Instead, use opaque colors or simulate transparency using halftone patterns (e.g. dots or halftones).',
            ],
            dontShowAgain: "Don't show again",
            priceInformation: 'For the DTF printing technology, a price of 0.50€ (excl. VAT) per item and additional print area is added.',
            headlineWarning: 'DTF Warning',
            transparencyWarning: 'This image contains transparent pixels and may look unexpected.',
            transparencyWarningUseDTG: 'We recommend printing your design with DTG.',
            continueDtf: 'Continue with DTF',
            continueDtg: 'Choose DTG (recommended)',
        },
        updateShopInfo: 'Your store must be updated in order to upload the product. You can do this <a href="/my-stores">here</a>.',
        transparencyWarning: 'This image contains transparent pixels and may look unexpected.',
        aiKeywordsLabel: 'Keywords',
        aiKeywordsPlaceholder: 'e.g. organic cotton, soft, premium, sustainable',
        aiToneLabel: 'Tone',
        aiToneProfessional: 'Professional',
        aiToneCasual: 'Casual',
        aiToneFriendly: 'Friendly',
        aiToneDaring: 'Daring',
        aiInstructionsLabel: 'Special instructions',
        aiInstructionsPlaceholder: 'Optional guidance (length, features to highlight, etc.)',
        aiGenerateButton: 'Generate with AI',
        aiGenerateAgainButton: 'Generate',
        aiKeepButton: 'Keep',
        aiPreviewLabel: 'Preview',
        aiGenerateReplaces: 'Replaces current description',
        aiGenerateError: 'Could not generate description. Please try again.',
        salesRegion: 'Sales region',
        noRegionSelected: 'No region selected',
        quickActions: {
            changeProduct: 'Change product',
            addDesign: 'Add design',
            changeProductTitle: 'Change Product',
            currentProduct: 'Current',
        },
        createMultipleProducts: 'Create Multiple Products',
    },
    multiDesigner: {
        title: 'Multi-Product Designer',
        subtitle: 'Design and create multiple products at once',
        loading: 'Loading...',
        loadingMockups: 'Generating mockups...',
        backToProducts: 'Back to Products',
        backToDesign: 'Back to Design',
        backToDesigner: 'Back to Designer',
        addProduct: 'Add Another Product',
        selectProduct: 'Select a Product',
        searchProducts: 'Search',
        searchPlaceholder: 'Search by name or type...',
        noProductsFound: 'No products found',
        maxReached: 'Maximum of {max} products reached',
        products: 'products',
        variants: 'variants',
        ready: 'Ready',
        incomplete: 'Incomplete',
        closeDesigner: 'Remove product',
        completeAllDesigners: 'Please complete all product designs before continuing',
        completeAllProducts: 'Please complete all product details before creating',
        confirmTitle: 'Confirm Your Products',
        confirmSubtitle: 'Review and finalize your product details',
        shopSelectionTitle: 'Select Shops',
        shopSelectionSubtitle: 'Choose which shops to add all products to',
        selectAtLeastOneShop: 'Please select at least one shop',
        createAllProducts: 'Create All Products',
        successTitle: 'Products Created',
        successMessage: 'Your products have been created successfully!',
        productsCreated: 'products created',
        productsFailed: 'products failed',
        viewProducts: 'View My Products',
    },
    publishProduct: {
        title: 'Add to Shop',
    },
    aiAccess: {
        title: 'Authorize AI access',
        request: '{client} is asking to act on your MarketPrint account.',
        scopeCatalogue: 'Browse the products you can print on',
        scopeUpload: 'Upload design images to your account',
        scopeCreate: 'Create and publish products to your connected shops',
        ownAccountOnly: 'It can only act on your own account, and you can revoke this at any time in your account settings.',
        allow: 'Allow',
        deny: 'Deny',
        unknownClient: 'An AI assistant',
        missingInteraction: 'This authorization link is invalid or has expired. Please start again from your AI assistant.',
        sessionExpired: 'Your session has expired. Please reload the page and sign in again.',
        failed: 'Could not complete the authorization. Please try again.',
    },
    accountSettings: {
        title: 'Settings',
        shopSettings: 'Shop Settings',
        noShops: 'No shops added yet.',
        subtitle: 'Manage your profile settings.',
        contactInfo: 'Contact details',
        paymentInfo: 'Payment information',
        email: 'E-Mail',
        tel: 'Telephone',
        billingAddress: 'Billing address',
        billingAddressTooltip: 'This is the address that will appear on the invoices.',
        senderAddress: 'Sender address',
        senderAddressTooltip: 'This is the address that appears as the sender on the shipping labels. Only addresses in Germany are permitted.',
        senderAddressEU: 'Sender address (EU)',
        senderAddressUSA: 'Sender address (USA)',
        senderAddressUSATooltip: 'This is the address that appears as the sender on the shipping labels. Only addresses in the USA are permitted.',
        paymentServiceProvider: 'Payment service',
        paymentServiceProviderEU: 'Payment service (EU)',
        paymentServiceProviderUS: 'Payment service (US)',
        billingAgreement: 'Billing agreement',
        deposited: 'Deposited',
        changePaymentMethod: 'Change payment method',
        tryAgain: 'Try again',
        addPayment: 'Add',
        changePayment: 'Change',
        deletePayment: 'Delete',
        deletePaymentTitle: 'Delete payment method',
        deletePaymentConfirm: 'Do you really want to delete this payment method?',
        deletePaymentDone: 'Payment method deleted',
        retryPayment: 'Retry failed payment',
        retryPaymentSuccess: 'Payment retry triggered',
        retryPaymentError: 'Payment retry failed',
        notifications: 'Notification',
        preferredLanguage: 'Preferred Language',
        preferredLanguageDescription:
            "When you're logged into MarketPrint, this is the language you see.<br/>You can change the language at any time.",
        productLanguage: 'Add Products to Your Shop',
        productLanguageDescription:
            'This changes the language of your product and the unit of measurement of the size chart when importing into your store.',
        preferredPrinterTypeTeeInBlue: 'Preferred Printer Type for Orders via TeeInBlue:',
        apiToken: 'API Token',
        apiTokenDescription:
            'Here you can generate an API Token to use with different services. After generating your token, you can only see it once. Please save it in a safe place. You can always generate a new token, which will invalidate the old one.',
        generate: 'Generate',
        regenerate: 'Regenerate',
        popup: 'Please allow the pop-up window to store your payment data',
        notificationsCheckbox: {
            failedPayment: 'Receive notification when payments fail',
            personalizedDesign: 'Receive notification when a personalized design needs to be uploaded',
            tips: 'Would you like to receive tips and information from MarketPrint by E-Mail?',
        },
        editBillingAddress: 'Edit billing address',
        address: {
            title: 'Address',
            firstName: 'First name',
            lastName: 'Last name',
            address1: 'Address 1',
            address2: 'Address 2',
            company: 'Company',
            phone: 'Phone',
            email: 'E-Mail',
            name: 'Name / Company',
            nameAddition: 'Addition (2nd line)',
            address1Street: 'Street',
            address1Number: 'House Number',
            city: 'City',
            zip: 'Postcode',
            countryCode: 'Country Code',
            countryName: 'Country',
            province: 'State',
            validate: {
                zipWarning: {
                    title: 'Invalid Postcode!',
                    content: 'This ZIP code is not valid. Please check your input.',
                },
            },
            noChanges: 'Please make changes before saving',
            phoneOrEmailRequired: 'Phone number or email is required',
            vatId: 'VAT ID',
            chooseExisting: '--- Choose existing address ---',
        },
        language: 'Language:',
        units: 'Units:',
        shoeSizes: 'Shoe Sizes:',
        editSenderAddressToasts: {
            success: 'Sender address saved successfully',
        },
        editInvoiceAddressToasts: {
            success: {
                content: 'Your invoice address has been saved successfully.',
            },
            unavailable: {
                title: 'Warning',
                content: 'We could not verify your VAT ID at the moment, but your address was saved. Please try again later.',
            },
            invalid: {
                content: 'The given VAT ID is not registered.',
            },
            format: {
                content: 'The given VAT ID does not have the right format. Plase recheck your input.',
            },
        },
        save: 'Save',
        editSenderAddress: 'Edit sender address',
        editSenderAddressEU: 'Edit sender address (EU)',
        editSenderAddressUSA: 'Edit sender address (USA)',
        general: 'Change address',
        selectPayment: 'Please choose',
        paypal: 'PayPal',
        creditCard: 'Credit card',
        notDeposited: 'Not deposited',
        deposit: 'Make a deposit',
        paymentError: 'Payment method not available',
        tib: 'TeeInBlue',
        connectTibProductInfo: 'Connect your TiB Product to MarketPrint',
        saveIntegrationApiInfosInfo: 'Save your TiB API information to beable to receive shipping updates in TeeInBlue',
        webhookUrl: 'Webhook URL',
        stockAvailabilityTitle: 'Stock Availability',
        stockAvailabilityCheckbox: 'Update stock availability automatically',
        stockAvailabilityDescription:
            'If this option is checked, your products are automatically set as sold out as soon as they are not available from our suppliers or the product has been discontinued by the manufacturer. <br> <br>If unchecked, then products will always be shown as available even if the product is discontinued or out of stock with our suppliers.',
        updateEmail: {
            title: 'Update Email',
            placeholder: 'New email',
            confirm: 'Confirm email',
            email: 'Email',
            button: 'Update Email',
            success: {
                title: 'Success',
                message: 'Please follow the instructions sent to your email to verify your new email address.',
            },
            error: {
                title: 'Update email error',
                emailExists: 'The given email is already registered.',
                rateLimit: 'Too many attempts. Please wait a moment and try again.',
                unknown: 'An unknown error occurred. Please try again later.',
            },
        },
        addShop: {
            title: 'Add shop',
            reconnectTitle: 'Shop has to be reconnected',
            howToLogin: 'Where do I find my URL?',
            add: 'Add',
            shopConnect: 'Connect',
            connectShopInfo: {
                etsy: 'Etsy is an online marketplace where small businesses can sell handmade products from categories such as jewelry, art, and fashion.',
            },
        },
        disconnectShop: {
            title: 'Disconnect Shop',
            description:
                'This will mark the shop as disconnected. Everything will work as before, but it is then possible to connect the shop to another account. If the shop is connected to another account, all products and designs that are relevant for that shop will be duplicated in the new account',
            disconnect: 'Disconnect Shop',
            reconnect: 'Reconnect Shop',
            statusConnected: 'Status: <b style="color: var(--color-secondary)">Connected</b>',
            statusDisconnected: 'Status: <b style="color: var(--color-primary)">Disconnected</b>',
        },
        mcpTokens: {
            title: 'AI agent access',
            description:
                'Create an access token to let an AI assistant browse your catalogue, upload designs and create products on your connected shops on your behalf. Treat a token like a password - anyone holding it can act on your account. Revoke it any time.',
            label: 'Name',
            labelPlaceholder: 'e.g. my AI assistant',
            created: 'Created',
            lastUsed: 'Last used',
            status: 'Status',
            never: 'Never',
            statusActive: 'Active',
            statusRevoked: 'Revoked',
            statusExpired: 'Expired',
            create: 'Create token',
            expiryNever: 'Never expires',
            expiryDays: 'Expires in {days} days',
            noTokens: 'No access tokens yet.',
            mintedTitle: 'Your new access token',
            mintedWarning: 'Copy it now - for your security it will not be shown again. If you lose it, create a new one.',
            copy: 'Copy',
            copied: 'Copied',
            copyFailed: 'Could not copy to clipboard. Please select the token and copy it manually.',
            dismiss: 'Done',
            revoke: 'Revoke',
            revokeTitle: 'Revoke access token',
            revokeConfirm: 'Revoke "{label}"? Anything using this token will immediately lose access. This cannot be undone.',
            revoked: 'Access token revoked.',
            revokeFailed: 'Could not revoke the token. Please try again.',
            mintFailed: 'Could not create the token. Please try again.',
        },
    },
    shopSelector: {
        noShops: 'No shops available',
        noShopSelected: 'No shop selected',
        allShopsSelected: 'All shops selected',
        notConnected: '(uninstalled)',
        notOnboarded: '(not onboarded)',
        disconnected: '(disconnected)',
        all: 'All Shops',
    },
    myProducts: {
        title: 'My products',
        editProducts: {
            title: 'Edit product',
            productTitle: 'Product title',
            shopDomain: 'Shop',
            productTitlePlaceholder: 'Product title',
            supportedPrinterTypes: 'Printer type:',
            productInfo: 'Product Information',
            syncsToAllShops: 'syncs to all shops',
            productDescription: 'Description:',
            productDescriptionPlaceholder: 'Enter product description...',
            metadataSyncInfo: 'Changes will be synced to all shops where this product is published.',
            shopSettings: 'Shop Settings',
            perShop: 'per shop',
            syncingToShops: 'Syncing to',
            shops: 'shops',
            editDesign: 'Edit Design',
            editDesignDescription: 'To change title, description, variants, or design, use the designer.',
            editDesignHint: 'Modify print files and design placement',
            variantPrices: 'Variant Prices',
            variantSyncInfo: 'Price changes will be synced to all shops where this product is published.',
            variantManagement: 'Variant Management',
            addVariants: 'Add Variants',
            removeVariant: 'Remove variant',
            toBeRemoved: 'To be removed',
            newVariant: 'New',
        },
        editAllProducts: 'Edit all products',
        editAllProductsWarning: 'This changes the printer type for all products of the selected shop. This cannot be undone.',
        editAllProductsError: 'An error occurred while saving the changes',
        editAllProductsSuccess: 'The printer type for all products of the selected shop has been successfully changed',
        editProductsError: 'An error occurred while saving the changes',
        editProductsSuccess: 'The printer type for the product has been successfully changed',
        multiExport: {
            button: 'Create Multi-Product',
            title: 'Create Multi-Product',
            steps: {
                products: 'Select Products',
                details: 'Title & Prices',
            },
            selectStoreTitle: 'Select Store',
            selectStoreSubtitle: 'Choose which store to combine products from',
            step1Title: 'Select Products',
            step2Title: 'Set title, description and prices',
            noEligibleProducts: 'No eligible products found for this shop',
            searchPlaceholder: 'Search products...',
            noSearchResults: 'No products match your search',
            variants: 'variants',
            selectedProducts: 'Selected products',
            detailsHeader: 'Product details',
            pricesHeader: 'Variant prices',
            previewTitle: 'Preview',
            productLabel: 'Product {number} - {title}',
            skuWarning: "Don't edit these variants' SKUs in Shopify after export - doing so breaks order fulfillment for that variant.",
            submit: 'Create product',
            createNew: 'Create new Multi-Product',
            success: 'Product created successfully:',
            partialFailure: 'The product was created, but some variants failed:',
            error: 'Failed to create the combined product. Please try again.',
            productLoadFailed: "Couldn't load this product. Please try again.",
        },
    },
    noResults: {
        text: 'There are no orders available yet',
        products: 'There are no products available in this category yet',
    },
    noShops: {
        connected: 'There are currently no shops connected. To connect a shop, go to the',
        settings: 'settings',
    },
    shared: {
        yes: 'Confirm',
    },
    invoices: {
        title: 'Invoices',
        startDate: 'Start date',
        endDate: 'End date',
        shop: 'Shop',
        download: 'PDF download',
        downloadCSV: 'CSV download',
        annotation:
            'The download of the pdf files may take some time. Please note that the maximum number of invoices is 5000. Download times vary, but it usually takes around 5 minutes to download 1000 invoices.',
        noResults: 'There are no invoices for this time period.',
        countFound: 'Invoices found within the selected time frame: {count}',
        countWarning:
            'Warning: The amount of invoices within the selected time frame exceeds the limit of {limit} invoices. Please adjust the time frame.',
        downloadDisabled:
            'Downloads are disabled because the invoice count exceeds the limit of {limit} invoices. Please adjust the time frame to proceed.',
    },
    login: {
        install1: `Sign in<br>to `,
        install2: ' ',
        shopUrl: 'Enter a Shopify Domain (SHOPNAME.myshopify.com):',
        redirect: 'Redirected...',
        login: 'Login',
        marketprint: 'MarketPrint',
        company: 'MarketPrint - MarketConsultive GmbH',
        companyAddress: 'Allgäuerstraße 20, 87719 Mindelheim, Deutschland',
        password: 'Password',
        registerInstead: 'Register instead',
        error: {
            title: 'Login error',
            rateLimit: 'Too many login attempts. Please wait a moment and try again.',
            emailNotConfirmed: 'This email address has not yet been confirmed.',
            invalidCredentials: 'Invalid credentials.',
            firstTimeApiCallFailed: 'Your account was created but there was an internal error. Please try to log in or register again.',
            unknown: 'An unknown error occurred. Please try again later.',
        },
    },
    emailResend: {
        title: 'Resend Confirmation Email',
        success: {
            title: 'Success',
            message: 'The confirmation email has been resent.',
        },
        error: {
            title: 'Resend error',
            rateLimit: 'Too many attempts. Please wait a moment and try again.',
            unknown: 'An unknown error occurred. Please try again later.',
        },
    },
    forgotPassword: {
        forgotPassword: 'Forgot password?',
        enterEmail: 'Please enter your email address to receive a password reset link.',
        resetPassword: 'Reset password',
        success: {
            title: 'Success',
            message: 'An email has been sent to your email address with a password reset link.',
        },
        error: {
            title: 'Reset password error',
            unknown: 'An unknown error occurred. Please try again later.',
        },
    },
    updatePassword: {
        success: {
            title: 'Success',
            message: 'Your password has been updated successfully.',
        },
        error: {
            title: 'Update password error',
            samePassword: 'The password should differ from the old password.',
        },
        confirm: 'Password Confirmation',
        button: 'Update password',
        placeholder: 'New password',
        title: 'Update password',
        nonceMessage: 'A code has been sent to your email address. Please enter the code below to continue.',
        noncePlaceholder: 'One-time code',
        nonceInvalid: 'The provided code is invalid.',
    },
    register: {
        register: 'Register',
        loginInstead: 'Login instead',
        error: {
            title: 'Registration error',
            rateLimit: 'Too many registration attempts. Please wait a moment and try again.',
            emailExists: 'This email address is already registered.',
            weakPassword:
                'The password you entered is too weak. The password must contain at least 8 characters and contain a capital/lowercase letter, a number and a special character.',
            unknown: 'An unknown error occurred. Please try again later.',
        },
        success: {
            title: 'Registration successful',
            message: 'Your registration was successful. Please check your emails to confirm your account.',
        },
    },
    onboarding: {
        title: 'Welcome to MarketPrint!',
        welcomeText: `Thank you for using our Print on Demand service!<br><br>
            We are a modern & passionate company that offers an all-in-one print on demand service and does everything to offer Shopify online merchants the best and easiest user experience in online commerce.<br>
            We are continuously working on our app and our service to make the Print on Demand business model accessible to everyone and to offer you the opportunity to access an ever-growing product portfolio and an automated ordering process.<br><br>
            We are always open to suggestions for improvements regarding our Shopify app. Feel free to call us for this or write to our support.<br><br>
            Have fun with the MarketPrint app and have lots of good sales,<br>
            Team MarketPrint`,
        privacy:
            "I have read the <a href='https://marketprint.de/agb/' target='blank'>Terms and Conditions</a> and <a href='https://marketprint.de/datenschutzerklarung-marketprint-app/' target='_blank'>Privacy Policy</a> and agree to them",
        emailNotifications: 'I would like to be informed by MarketPrint about new products and news by e-mail',
        formTitle: 'Very important for the perfect start:',
        formText: `In order for your incoming orders to be processed automatically, you must enter your payment method. We offer PayPal or credit card as an option and recommend that you deposit your payment method & billing address now for a smooth start.<br><br>
            Please fill out the form and choose the payment method that is right for you:`,
        billingAddress: 'Add billing address:',
        name: 'Name:',
        namePlaceholder: 'Enter your name',
        firstName: 'First name:',
        firstNamePlaceholder: 'Enter first name',
        company: 'Name / Company:',
        companyPlaceholder: 'Specify your name or company name',
        addressStreet: 'Street:',
        addressStreetPlaceholder: 'Add street',
        addressNumber: 'House number:',
        addressNumberPlaceholder: 'Add house number',
        postcode: 'ZIP:',
        postcodePlaceholder: 'Add ZIP',
        country: 'Country:',
        countryPlaceholder: 'Select a country',
        paymentMethod: 'Select a payment service provider:',
        thankYouTitle: 'You did it! 🎉',
        thankYouText: `You have done everything and are ready to create and launch your own brand.<br>
            Let's create your very first product together. You will see how easy and fast this is.<br><br>
            Try it out right now, just click on the button and let's create your first product directly with one of our bestsellers.`,
        thankYouNext: 'Get started now!',
        thankYouBack: 'Skip',
        city: 'City:',
        cityPlaceholder: 'Add city',
        error: {
            title: 'Account information could not be stored',
            backendContent: 'Errors when storing the data',
        },
        regionLabel: 'Where do you mainly sell?',
        sourceLabel: 'How did you hear about us?',
        sourceSelect: 'Please select...',
        sourceOtherLabel: 'Other (please specify)',
        sourceOtherPlaceholder: 'Please specify...',
        sourceFriends: 'Friends & Acquaintances',
        sourceOther: 'Other',
        sourceAppStore: 'App Store',
        sourceGoogle: 'Google Search',
        sourceSocial: 'Social Media',
        tiktokResponsiblePerson: {
            title: 'Responsible Person (EU Compliance)',
            hint: 'TikTok requires EU shops to register a responsible person for product compliance. This person is liable to authorities for compliance with EU regulations. Please fill in all fields — this information is sent directly to TikTok and is required to export products.',
            name: 'Name / Company name:',
            namePlaceholder: 'John Doe or Example Ltd.',
            email: 'Email:',
            emailPlaceholder: 'responsible@example.com',
            phoneCountryCode: 'Country code:',
            phoneCountryCodePlaceholder: '+49',
            phoneLocalNumber: 'Phone number:',
            phoneLocalNumberPlaceholder: '15123456789',
            street: 'Street & house number:',
            streetPlaceholder: '1 Example Street',
            postalCode: 'Postal code:',
            postalCodePlaceholder: '12345',
            country: 'Country:',
            error: 'The data could not be submitted to TikTok. Please check your entries.',
        },
    },
    success: {
        title: 'Success',
    },
    error: {
        title: 'Error',
        content: 'An error occurred',
    },
    common: {
        existing: 'Existing',
        edit: 'Edit',
        delete: 'Delete',
        actions: 'Actions',
        update: 'Update',
        cancel: 'Cancel',
        save: 'Save',
        savings: 'Savings',
        shop: 'Shop',
        publish: 'Publish',
        unpublish: 'Unpublish',
        sync: 'Sync',
        published: 'Published',
        success: 'Done',
        failed: 'Something went wrong',
    },
    bundling: {
        themeCustomPlacement: 'Want them somewhere else on the page? Add the blocks yourself instead:',
        turnOnInTheme: 'Turn on in your theme',
        styleLoadFailed: 'Could not load the look of this store.',
        styleSaveFailed: 'Could not save the look. Please try again.',
        styleSaved: 'Saved. Your shop shows the new look now.',
        styleReset: 'Reset to default',
        styleCustomCssHint:
            'For anything not covered above. Use the .mp-bundle classes, e.g. .mp-bundle__title. Shown exactly in your shop; the preview here is only a rough view.',
        styleCustomCss: 'Custom CSS',
        styleButtonTextColor: 'Button text colour',
        styleButtonColor: 'Button colour',
        styleButtonText: 'Button text',
        styleButton: 'Add to cart button',
        styleBadgeTextColor: 'Badge text colour',
        styleBadgeColor: 'Badge colour',
        styleShowBadge: 'Show the "Save %" badge',
        stylePriceColor: 'Bundle price colour',
        styleTextColor: 'Text colour',
        styleProducts: 'Products and prices',
        styleHeadingColor: 'Heading colour',
        styleHeadingSize: 'Heading size: {value}px',
        styleEmptyDefault: "Leave empty for the default in your shop's language.",
        styleHeadingText: 'Heading text',
        styleHeading: 'Heading',
        styleCornerRadius: 'Corner radius: {value}px',
        styleBorderWidth: 'Border width: {value}px',
        styleBorderColor: 'Border colour',
        styleBackground: 'Background',
        styleBox: 'Box',
        sampleProduct: 'Sample product {n}',
        customizePreviewSample: 'Shown with sample products, as this store has no bundle yet.',
        customizePreviewBundle: 'Shown with your first bundle.',
        customizeSelectStore: 'Choose the store to customise',
        customizeIntro:
            'Choose how the bundle box looks on your bundle pages. It applies to all bundles of the store; the subtitle is set per bundle.',
        customizeTitle: 'Customise the bundle box',
        customizeLink: 'Customise look',
        subtitleLabel: 'Subtitle (optional)',
        subtitlePlaceholder: 'e.g. A funny gift for two',
        previewTitle: 'Preview',
        previewNote: 'How the bundle box will look in your shop, with your shop\'s style from "Customise look".',
        previewHeading: 'Buy the set',
        previewSave: 'Save {percent}%',
        previewAddToCart: 'Add Bundle to Cart',
        themeActive: 'Active',
        themeInactive: 'Not active',
        themeActiveText: 'The bundles show next to Add to cart on every product page.',
        themeInactiveText: 'MarketPrint Bundles is not switched on in your theme yet, so shoppers do not see your bundles.',
        openThemeEditor: 'Open theme editor',
        themeTitle: 'Show bundles in your shop',
        themeText:
            'Click the button, switch on "MarketPrint Bundles" and click Save. Then the bundles show next to Add to cart on every product page by themselves, also for bundles you create later.',
        addBundleBlock: 'Add bundle block',
        addRelatedBlock: 'Add related bundles block',
        searchProducts: 'Search products',
        noProductMatch: 'No product found',
        selectStoreTitle: 'Select Store',
        selectStoreSubtitle: 'Choose the store to create bundles for',
        title: 'Product Bundling',
        comingSoon: 'Coming Soon',
        add: 'Add',
        remove: 'Remove',
        selected: 'Selected Products',
        variants: 'Variants',
        selectVariant: 'Select Variant',
        originalPrice: 'Regular price',
        discountedPrice: 'Bundle price',
        bundleTitle: 'Bundle Title',
        bundleDescription: 'Bundle Description',
        published: 'Published',
        saveBundle: 'Save bundle',
        hiddenNoSubscription: 'Hidden: activate Bundling to show it',
        clear: 'Clear',
        save: 'Save',
        addNewTile: 'Add new tile',
        selectProduct: 'Select Product',
        selectOption1: 'Option 1',
        selectOption2: 'Option 2',
        color: 'Color',
        size: 'Size',
        loadingProducts: 'Loading products...',
        noProducts: 'No products available',
        noImage: 'No image',
        defaultTitle: 'Bundle',
        deleteConfirm: 'Delete this bundle?',
        removeProductConfirm: 'Remove this product from the bundle?',
        noShopDomain: 'No shop domain selected. Please select a shop first.',
        bundleUpdated: 'Bundle updated successfully!',
        bundleUpdateFailed: 'Failed to update bundle. Please try again.',
        bundleSaved: 'Bundle saved successfully!',
        bundleSaveFailed: 'Failed to save bundle. Please try again.',
        bundleDeleteFailed: 'Failed to delete bundle',
        editBundle: 'Edit Bundle',
        createBundle: 'Create New Bundle',
        subscriptionTitle: 'Bundling - Subscription',
        activate: 'Activate',
        deactivate: 'Deactivate',
        change: 'Change',
        myBundles: 'My bundles',
        intro: 'Combine products from your shop into a bundle sold at a lower price. Shoppers pick size and colour on the bundle page, and the discount is applied automatically in the cart.',
        modalHint: 'Choose at least two products. The regular price comes from your shop; enter what each product costs inside the bundle.',
        noProductsHint: 'Only products exported to this shop can be bundled.',
        needTwoProducts: 'Add at least two different products or variants.',
        chooseAllOptions: 'Choose all options (for example size and colour) for every product.',
        missingPrice: 'Every product needs a regular price above 0 and a bundle price (0 for a free item).',
        bundleTotalZero: 'The bundle price cannot be 0 for the whole bundle.',
        bundleAboveRegular: 'The bundle price is higher than the regular price for: {titles}',
        notActive:
            'Bundling is not active for this shop. You can create and edit bundles, but publishing them to your store needs an active subscription.',
        activateBundling: 'Activate bundling',
        manageBundles: 'Manage bundles',
        openInShopify: 'Open in Shopify',
        saveAndSync: 'Save and sync',
        bundleSynced: 'Bundle synced to Shopify.',
        bundleSavedAndSynced: 'Bundle saved and synced to Shopify.',
        unpublishConfirm: 'Unpublish this bundle? Its product will be set to draft in Shopify and no longer be shown in your shop.',
        noBundles: 'No bundles for this shop yet.',
        products: 'Products',
        regularTotal: 'Regular price',
        viewInShop: 'View in shop',
        subscriptionIntro:
            'Bundling is activated per shop. Once it is active, the bundles you publish appear in that shop and the bundle discount applies at checkout.',
        active: 'Active',
        includedVip: 'Included for free (VIP)',
    },
    header: {
        notifications: 'Notifications',
    },
    countries: {
        Deutschland: 'Germany',
        Österreich: 'Austria',
        Schweiz: 'Switzerland',
        Andorra: 'Andorra',
        Belgien: 'Belgium',
        Bulgarien: 'Bulgaria',
        Dänemark: 'Denmark',
        Estland: 'Estonia',
        Finnland: 'Finland',
        Frankreich: 'France',
        Griechenland: 'Greece',
        Irland: 'Ireland',
        Italien: 'Italy',
        Kroatien: 'Croatia',
        Lettland: 'Latvia',
        Luxemburg: 'Luxembourg',
        Monaco: 'Monaco',
        Niederlande: 'Netherlands',
        Norwegen: 'Norway',
        Polen: 'Poland',
        Portugal: 'Portugal',
        'San Marino': 'San Marino',
        Schweden: 'Sweden',
        Slowakei: 'Slovakia',
        Slowenien: 'Slovenia',
        Spanien: 'Spain',
        'Tschechische Republik': 'Czech Republic',
        Ungarn: 'Hungary',
        Vatikanstadt: 'Vatican City',
        'Vereinigtes Königreich': 'United Kingdom',
        Zypern: 'Cyprus',
        Kosovo: 'Kosovo',
        Litauen: 'Lithuania',
        Malta: 'Malta',
        Rumänien: 'Romania',
        Albanien: 'Albania',
        'Bosnien und Herzegowina': 'Bosnia and Herzegovina',
        Liechtenstein: 'Liechtenstein',
        Mazedonien: 'Macedonia',
        Moldau: 'Moldova',
        Montenegro: 'Montenegro',
        Serbien: 'Serbia',
        'Vereinigte Staaten': 'United States',
        'Zone 1': 'Zone 1',
        'Zone 2': 'Zone 2',
        'Zone 3': 'Zone 3',
        'Zone 4': 'Zone 4',
    },
    codeToCountry: {
        AE: 'United Arab Emirates',
        AT: 'Austria',
        BE: 'Belgium',
        BG: 'Bulgaria',
        CY: 'Cyprus',
        CZ: 'Czechia',
        DE: 'Germany',
        DK: 'Denmark',
        EE: 'Estonia',
        EL: 'Greece',
        ES: 'Spain',
        FI: 'Finland',
        FR: 'France',
        GR: 'Greece',
        HR: 'Croatia',
        HU: 'Hungary',
        IE: 'Ireland',
        IT: 'Italy',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        MT: 'Malta',
        NL: 'Netherlands',
        PL: 'Poland',
        PT: 'Portugal',
        RO: 'Romania',
        SE: 'Sweden',
        SI: 'Slovenia',
        SK: 'Slovakia',
        GB: 'United Kingdom',
        CH: 'Switzerland',
        NO: 'Norway',
        US: 'United States',
    },
    shippingTable: {
        canvas: 'Canvas',
        poster: 'Poster',
        basePrice: 'Base Price',
        perAdditionalProduct: 'Per Additional Product',
    },
    time: {
        today: 'Today',
        nDaysAgo: '{n} days ago',
        '1DayAgo': '1 day ago',
    },
    unitSystems: {
        metric: 'cm/ml (Metric)',
        imperial: 'inch/oz (Imperial)',
        both: 'cm + inch (Both)',
    },
    shoeSizeSystem: {
        eu: 'EU',
        us: 'US',
        uk: 'UK',
    },

    affiliateProgram: {
        title: 'Affiliate Program',
        activeShopsLastYear: 'Stores younger than 1 year',
        allShops: 'All Shops',
        payouts: 'Payouts',
        payoutDate: 'Payout Date',
        payoutAmount: 'Payout Amount',
        payoutStatus: 'Payout Status',
        btnDownloadPayout: 'Download Payout',
        payoutInfo: 'Payout Information',
        paymentServiceProvider: 'Payment service',
        billingAgreement: 'Billing agreement',
        deposited: 'Deposited',
        addNewPaymentMethod: 'Add new payment method',
        changePaymentMethod: 'Update payment method',
        tryAgain: 'Try again',
        popup: 'Please allow the pop-up window to store your payment data',
        selectPayment: 'Please choose',
        paypal: 'PayPal',
        creditCard: 'Credit card',
        billingAddress: 'Billing address',
        paymentStatus: {
            open: 'Open',
            invoice_upload_pending: 'Invoice Upload Pending',
            invoice_being_verified: 'Invoice Being Verified',
            payment_pending: 'Payment Pending',
            paid: 'Paid',
            failed: 'Failed',
        },
    },
    marketPrintSolutions: {
        title: 'MarketPrint Solutions',
        returnmanagement: 'Returnmanagement',
        itemOverview: 'Item Overview',
        subscription: 'Subscription',
        bundling: 'Bundling',
    },
    subscription: {
        changeFailed: 'Your subscription could not be changed',
        confirmFailed: 'We could not confirm the subscription with Shopify. Nothing was changed. Please try again in a minute.',
        modal: {
            title: 'Change subscription plan',
            intro: 'Select which modules you want to use. Both are billed through one Shopify subscription.',
            planSelectionLabel: 'Selection of modules',
            conditionsTitle: 'Overview',
            recurringInfo: 'Both modules share one Shopify subscription. You approve a spending limit once, and the fees are charged against it.',
            cancel: 'Cancel',
            save: 'Save',
            saving: 'Saving …',
            noPlanSelected: 'Warning: all subscriptions will be cancelled.',
            included: 'Included',
            notIncluded: 'Not included',
            table: {
                feature: 'Feature',
                returnManagement: 'Return Management',
                bundling: 'Bundling',
            },
        },
        plan: {
            returnOnly: {
                label: 'Return Management',
                description: 'Manage returns, refunds and store returns.',
            },
            bundlingOnly: {
                label: 'Bundling',
                description: 'Offer bundles and upsells to increase the order value.',
            },
        },
        features: {
            returnManagement: {
                core: 'Return Management',
                automation: 'Automation workflows',
            },
            bundling: {
                core: 'Bundle configuration',
                upsell: 'Upsell logic in checkout',
            },
            support: 'Support & Updates',
        },
        actions: {
            configureReturn: 'Configure Return Management',
            configureBundling: 'Configure Bundling',
        },
    },
    betaFeatures: {
        workInProgress: 'Feature work in progress',
        comingSoon: 'Coming soon',
    },
    wallet: {
        title: 'Wallet',
        balance: 'Balance',
        activate: 'Activate wallet',
        activateHint: 'Activate the wallet for this region to top it up by bank transfer and pay orders from it automatically.',
        activationRequirementHint: 'Not available yet: {orderCount} of {requiredOrderCount} required orders in the last 90 days.',
        payout: 'Request payout',
        payoutRequested: 'Payout requested successfully',
        payoutFailed: 'Payout request failed. Please try again.',
        payoutConfirm:
            'The entire wallet balance will be paid out to your bank account. You will then receive an email with the exact instructions. Do you want to continue?',
        tableHeaders: {
            date: 'Date',
            description: 'Description',
            invoiceNumber: 'Invoice',
            amount: 'Amount',
            status: 'Status',
        },
        fundingTitle: 'Funding instructions',
        fundingAccountHolder: 'Account holder',
        fundingAccountNumber: 'Account number',
        fundingSortCode: 'Sort code',
        fundingRoutingNumber: 'Routing number',
        fundingSwiftCode: 'SWIFT/BIC',
        fundingBankName: 'Bank',
        fundingNetworkAba: 'Domestic (ACH / wire)',
        fundingNetworkSwift: 'International (SWIFT)',
        fundingHint:
            'These bank details belong to our payment provider (Stripe) and are used solely to top up your wallet balance – not MarketPrint directly. Please transfer to the exact account holder and IBAN shown; the amount will be credited to your wallet automatically.',
        transactions: 'Transactions',
        viewTransactions: 'View transactions',
        methodOrderTitle: 'Payment method order',
        methodOrderSaved: 'Payment method order saved',
        noMethodsActive: 'No payment methods active',
        notConfigured: 'not configured',
        methodActivate: 'Activate',
        methodDeactivate: 'Deactivate',
        lastMethodHint: 'At least one payment method must stay active.',
        moveUp: 'Move up',
        moveDown: 'Move down',
        status: {
            completed: 'Completed',
            failed: 'Failed',
            pending: 'Pending',
        },
        methods: {
            wallet: 'Wallet',
            credit_card: 'Credit card',
            paypal: 'PayPal',
        },
        notifications: {
            title: 'Wallet',
            lowBalance: 'Notify me by email when the balance is low',
            threshold: 'Threshold',
            thresholdHint: 'If your balance drops below this amount, you will be notified by email. Minimum 30.',
            funding: 'Notify me by email when funds arrive',
            notActiveWarning: 'Wallet is currently not the active payment method for this region.',
        },
        descriptionKey: {
            order_debit: 'Charge for order {orderReference}',
            order_refund: 'Refund for order {orderReference}',
            stripe_bank_transfer: 'Bank transfer from {senderName}',
            payout_expired: 'Payout expired — balance reversed (Refund {refundId})',
            payout_pending: 'Payout to bank account requested',
            payout_completed: 'Payout to bank account completed',
            payout_failed: 'Payout to bank account failed',
            payout_reversed: 'Payout failed, amount reversed ({errorMessage})',
            fallback: '{description}',
        },
    },
};

export default app;
